var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14516 11.858C8.13647 11.858 8.12759 11.8579 8.11871 11.8577C7.85899 11.8503 7.614 11.7364 7.44098 11.543L4.98221 8.79181C4.63466 8.40289 4.66809 7.80581 5.05701 7.45825C5.44593 7.11032 6.04301 7.14413 6.39057 7.53305L8.1835 9.53924L14.1046 3.61833C14.4731 3.24962 15.0715 3.24962 15.44 3.61833C15.8089 3.98723 15.8089 4.58525 15.44 4.95396L8.81288 11.5813C8.63551 11.7589 8.39525 11.858 8.14516 11.858Z",
    fill: "#16A665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.8131 17 0 13.1869 0 8.5C0 3.8131 3.8131 0 8.5 0C10.0547 0 11.5762 0.423867 12.8996 1.22608C13.3458 1.49638 13.4882 2.07702 13.2181 2.52318C12.9476 2.96933 12.3669 3.11194 11.9208 2.84146C10.8925 2.21831 9.70946 1.88889 8.5 1.88889C4.85463 1.88889 1.88889 4.85463 1.88889 8.5C1.88889 12.1454 4.85463 15.1111 8.5 15.1111C12.1454 15.1111 15.1111 12.1454 15.1111 8.5C15.1111 8.21912 15.0932 7.93579 15.0582 7.65793C14.9925 7.14038 15.3589 6.66778 15.8765 6.60223C16.394 6.53631 16.8665 6.90313 16.932 7.4205C16.9771 7.77693 17 8.13998 17 8.5C17 13.1869 13.1869 17 8.5 17Z",
    fill: "#16A665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.b6cc4fc3b4e4f54698f69b1328eea642.svg";
export { ForwardRef as ReactComponent };